var exports = {
  "kL": "x93eb46d8--a08404--container",
  "vK": "x93eb46d8--a08404--banner",
  "QH": "x93eb46d8--a08404--banner--red",
};

module.exports = exports;
